import React from "react";
import i18n from "i18n";

const NotFound: React.FC<Record<string, any>> = () => {
  return <div>{i18n.t("common.notFound")}</div>;
};

export default NotFound;
